/* RESPONSIBLE TEAM: team-ai-agent */
import Model, { attr } from '@ember-data/model';

export default class FinIngestionStates extends Model {
  @attr('boolean') declare hasIngestedContent: boolean;
  @attr('boolean') declare helpCenterIsTurnedOn: boolean;
  @attr('boolean') declare hasStartedImport: boolean;
  @attr('number') declare contentBytesize: number;
}
